import { HookTypes } from '../../../models/category/HookTypes';
import { ConfirmationType } from '../../../models/confirmation/ConfirmationEntity';
import { ConfirmationMessageType } from '../../../services/commands/UserInteractor';
import { getFirstPendingCommandConfirmation } from '../../selectors/confirmation';
import { getActiveCategoryId } from '../../selectors/content';
import catalogs from '../../slices/catalogs';
import categoryHook from '../../slices/categoryHook';
import commands from '../../slices/commands';
import confirmation from '../../slices/confirmation';
import hierarchy from '../../slices/hierarchy';
import { createAppListener, postDispatch } from '../listenerHelpers';

const confirmationDialogListener = createAppListener();

confirmationDialogListener.startListening(
  postDispatch(
    confirmation.approve,
    (_payload, _state, dispatch, prevState) => {
      const pendingConfirmation = getFirstPendingCommandConfirmation(prevState);

      if (pendingConfirmation?.type !== ConfirmationType.DATASET) {
        return;
      }

      const {
        dataset,
        action: { hook, args, command },
      } = pendingConfirmation;

      dispatch(
        commands.execute({
          datasetId: dataset,
          command,
          args,
          hook: hook ? HookTypes.OPEN : undefined,
        })
      );
    }
  )
);

confirmationDialogListener.startListening(
  postDispatch(
    confirmation.approveCatalogs,
    ({ answer }, state, dispatch, prevState) => {
      const pendingConfirmation = getFirstPendingCommandConfirmation(prevState);

      if (
        (pendingConfirmation?.type !== ConfirmationType.CATALOGS &&
          pendingConfirmation?.type !== ConfirmationType.HIERARCHY) ||
        getActiveCategoryId(state) !== pendingConfirmation.action.args.treeId
      ) {
        return;
      }

      const {
        action: { args, command },
      } = pendingConfirmation;
      const { treeId: catalogId, nodeId, parentId } = args;

      if (
        command === ConfirmationMessageType.MOVE_HIERARCHY &&
        Array.isArray(nodeId)
      ) {
        dispatch(
          hierarchy.move({
            categoryId: catalogId,
            moveIds: nodeId,
            newParentId: parentId,
          })
        );
        return;
      }

      if (
        command === ConfirmationMessageType.MOVE_IN_CATALOG &&
        Array.isArray(nodeId)
      ) {
        dispatch(
          catalogs.moveIn({ catalogId, moveIds: nodeId, newParentId: parentId })
        );
        return;
      }

      if (command === ConfirmationMessageType.CREATE_CATALOG && answer) {
        dispatch(
          catalogs.create({ catalogId, parentNodeId: nodeId, name: answer })
        );
      }

      if (command === ConfirmationMessageType.RENAME_CATALOG && answer) {
        dispatch(catalogs.rename({ catalogId, nodeId, name: answer }));
      }

      if (command === ConfirmationMessageType.DELETE_CATALOG) {
        dispatch(catalogs.delete({ catalogId, nodeId }));
      }

      if (command === ConfirmationMessageType.MOVE_CATALOG) {
        dispatch(catalogs.move({ catalogId, nodeId, newParentId: parentId }));
      }
    }
  )
);

confirmationDialogListener.startListening(
  postDispatch(confirmation.close, (_payload, _state, dispatch, prevState) => {
    const pendingConfirmation = getFirstPendingCommandConfirmation(prevState);

    if (
      pendingConfirmation?.type === ConfirmationType.DATASET &&
      pendingConfirmation.action.hook
    ) {
      dispatch(categoryHook.cancel(pendingConfirmation));
    }
  })
);

export default confirmationDialogListener.middleware;
